import { IResponse } from "models";

export enum ActionType {
  GET_PATIENT_LIST = "action/GET_PATIENT_LIST",
  GET_PATIENT_LIST_SUCCESS = "action/GET_PATIENT_LIST_SUCCESS",
  GET_PATIENT_LIST_ERROR = "action/GET_PATIENT_LIST_ERROR",
  GET_PATIENT_LIST_RESET = "action/GET_PATIENT_LIST_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface PatientsPayload {
  page: number;
  per_page: number;
  user_name?: string;
  from_date?: string;
  to_date?: string;
  join_from_date?: string;
  join_to_date?: string;
  identity_code?: string;
  is_in_super_city: boolean;
}

interface List {
  id: number;
  first_name: string;
  last_name: string;
  gender: number;
  age: number;
  date_of_birth: string;
}
export interface IPatientData {
  total_patients: number;
  total_patients_in_super_city: number;
  users: List[];
}

export interface IPatientListResponse extends IResponse {
  result: IPatientData;
  total_record: number;
}
